// Firefox before 153 has no transport selection and flags the pair itself with `selected`.
type CandidatePairStats = RTCIceCandidatePairStats & { selected?: boolean };

// Reports only what ICE says it chose. No RTT filter and no priority guess: a stale
// pair from an earlier negotiation can outrank the live one.
export const selectedCandidatePair = (report: RTCStatsReport): CandidatePairStats | undefined => {
  const pairs: CandidatePairStats[] = [];
  let selectedPairId: string | undefined;
  report.forEach((stat) => {
    if (stat.type === 'candidate-pair') {
      pairs.push(stat);
    } else if (stat.type === 'transport' && stat.selectedCandidatePairId) {
      selectedPairId = stat.selectedCandidatePairId;
    }
  });
  return (
    pairs.find((pair) => selectedPairId !== undefined && pair.id === selectedPairId) ??
    pairs.find(
      (pair) => pair.state === 'succeeded' && (pair.nominated === true || pair.selected === true)
    )
  );
};
